<template>
  <div>
    <b-container fluid>
      <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items" />

      <b-card class="mb-1">
        <b-form-group v-for="(canEditField, canEditField_i) in canEditFields" :key="canEditField.key"
          :id="'grp_txt_' + canEditField.key" :label="canEditField.label + ':'" :label-for="'txt_' + canEditField.key"
          label-size="sm">
          <b-form-input :id="'txt_' + canEditField.key" type="text" required placeholder
            v-model="product_obj[canEditField.key]"></b-form-input>
        </b-form-group>

        <!-- <b-button class="float-right" type="submit" variant="primary" @click="submitForm()">Submit</b-button> -->
      </b-card>

      <div style="display: flex; justify-content: space-between;" class="mb-3">
        <b-button class="mt-3 float-right" type="submit" variant="danger" @click="confirmDeleteProduct">
          Delete
        </b-button>

        <b-button class="mt-3 float-right" type="submit" variant="primary" @click="submitForm()">Submit</b-button>
      </div>

      <b-modal ref="modal_delete_product" title="Confirm Delete" ok-title="Delete" ok-variant="danger"
        cancel-title="Cancel" @ok="deleteProduct" centered>
        Are you sure you want to delete this product?
      </b-modal>

      <b-modal ref="modal_precheck" title="Confirm SKU Change" ok-title="Yes, Proceed" ok-variant="primary"
        cancel-title="Cancel" @ok="confirmPrecheckUpdate" centered>
        <div>
          <p v-if="hasPrecheckImpact">The following records will be affected by this SKU change:</p>

          <b-list-group v-if="hasPrecheckImpact" flush>
            <b-list-group-item v-for="(count, table) in filteredPrecheckSummary" :key="table"
              class="d-flex justify-content-between align-items-center">
              <span>{{ formatTableName(table) }}</span>
              <b-badge variant="danger" pill>{{ count }}</b-badge>
            </b-list-group-item>
          </b-list-group>

          <p v-else class="text-muted mb-2">
            No dependent records detected. Please review the warnings below before proceeding.
          </p>

          <div v-if="sku_conflict" class="text-danger font-weight-bold mb-2 mt-2">
            ⚠️ Product SKU <b>{{ product_obj.product_sku }}</b> already exists.
            <div v-if="sku_conflict_with" class="font-weight-normal mt-1">
              Conflicts with:
              <div class="mb-0">
                <div>Product SKU: <b>{{ sku_conflict_with.product_sku }}</b></div>
                <div>Channel SKU: <b>{{ sku_conflict_with.channel_sku || '-' }}</b></div>
                <div>Description: <b>{{ sku_conflict_with.product_description_en || '-' }}</b></div>
              </div>
            </div>
          </div>

          <div v-if="channel_sku_conflict" class="text-danger font-weight-bold mb-2">
            ⚠️ Channel SKU <b>{{ product_obj.channel_sku }}</b> already exists.
            <div v-if="channel_sku_conflict_with" class="font-weight-normal mt-1">
              Conflicts with:
              <div class="mb-0">
                <div>Product SKU: <b>{{ channel_sku_conflict_with.product_sku }}</b></div>
                <div>Channel SKU: <b>{{ channel_sku_conflict_with.channel_sku || '-' }}</b></div>
                <div>Description: <b>{{ channel_sku_conflict_with.product_description_en || '-' }}</b></div>
              </div>
            </div>
          </div>


          <p class="mt-3">
            Please confirm if you want to proceed with the update.
          </p>
        </div>
      </b-modal>


      <b-modal ref="modal_delete_precheck" title="Cannot Delete Immediately" ok-title="Force Delete" ok-variant="danger"
        cancel-title="Cancel" @ok="deleteProduct" centered>
        <div>
          <p>The following records are still linked to this product:</p>
          <b-list-group flush>
            <b-list-group-item v-for="(count, table) in filteredPrecheckSummary" :key="table"
              class="d-flex justify-content-between align-items-center">
              <span>{{ formatTableName(table) }}</span>
              <b-badge variant="danger" pill>{{ count }}</b-badge>
            </b-list-group-item>
          </b-list-group>
          <p class="mt-3 text-danger font-weight-bold">Are you sure you want to force delete this product?</p>
        </div>
      </b-modal>


    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

export default {
  name: "ProductMasterEdit",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      sku_conflict_with: null,
      channel_sku_conflict_with: null,
      order_master_products: [],
      canEditFields: [
        {
          key: "channel",
          label: "channel"
        },
        {
          key: "primary_category",
          label: "primary_category"
        },
        {
          key: "product_sku",
          label: "product_sku"
        },
        {
          key: "channel_sku",
          label: "channel_sku"
        },
        {
          key: "other_sku",
          label: "other_sku"
        },
        {
          key: "lot_1",
          label: "lot_1"
        },
        {
          key: "lot_2",
          label: "lot_2"
        },
        {
          key: "vendor",
          label: "vendor"
        },
        {
          key: "brand",
          label: "brand"
        },
        {
          key: "product_description_en",
          label: "product_description_en"
        },
        {
          key: "height_cm",
          label: "height_cm"
        },
        {
          key: "width_cm",
          label: "width_cm"
        },
        {
          key: "depth_cm",
          label: "depth_cm"
        },
        {
          key: "units_ctn",
          label: "units_ctn"
        },
        {
          key: "actual_weight_kg",
          label: "actual_weight_kg"
        },
        {
          key: "shipping_weight_kg",
          label: "shipping_weight_kg"
        },
        {
          key: "expiration_date",
          label: "expiration_date"
        },
        {
          key: "default_picking_location",
          label: "default_picking_location"
        },
        {
          key: "expirylot_mandate",
          label: "expirylot_mandate"
        },
      ],
      breadcrumb_items: [
        {
          text: "products",
          to: { name: "products" }
        },
        {
          text: "Edit",
          active: true
        }
      ],
      product: {},
      history_items: [],
      history_fields: [
        {
          key: "updated_at",
          label: "Updated at"
        },
        {
          key: "status",
          label: "Status"
        },
        {
          key: "pod_image",
          label: "POD"
        },
        {
          key: "updated_by",
          label: "Updated by"
        }
      ],
      loader: false,
      items: [],
      product_obj: {},
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      manual_return_order_id: "",
      updating_item: false,
      search_criteria: {
        keyword: "",
        status_selected: null
      },
      status_options: [
        {
          value: null,
          text: "All Status"
        },
        {
          value: "Pending",
          text: "Pending"
        },
        {
          value: "In-Transit",
          text: "In-Transit"
        },
        {
          value: "Returning to GOLS Warehouse",
          text: "Returning to GOLS Warehouse"
        },
        {
          value: "Successful Delivery",
          text: "Successful Delivery"
        },
        {
          value: "Returned to Warehouse",
          text: "Returned to Warehouse"
        }
      ],
      reschedule_type_selected: "before",
      reschedule_type_options: [
        {
          value: "before",
          text: "before"
        },
        {
          value: "on",
          text: "on"
        },
        {
          value: "after",
          text: "after"
        }
      ],
      reschedule_date: moment().format("YYYY-MM-DD"),
      showAlert_success: false,
      alert_success_message: "",
      user_id: false,
      original_product_sku: "",
      original_channel_sku: "",
      precheckSummary: {},
      pendingProductData: null,
      sku_conflict: false,
      channel_sku_conflict: false,
    };
  },
  computed: {
    filteredPrecheckSummary() {
      const result = {};
      for (const key in this.precheckSummary) {
        if (parseInt(this.precheckSummary[key]) > 0) result[key] = this.precheckSummary[key];
      }
      return result;
    },
    hasPrecheckImpact() {
      return Object.keys(this.filteredPrecheckSummary).length > 0;
    }
  },
  async created() {
    await this.getProduct();
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  methods: {
    formatTableName(key) {
      const map = {
        tbl_wms_product_inventory: "Product Inventory",
        tbl_wms_transaction_log: "Transaction Log",
        tbl_product_virtual: "Virtual Kit",
        tbl_product_virtual_reverse: "Reverse Virtual Kit",
        tbl_committed_order_record: "Committed Orders",
        tbl_order_master_product: "Order Master (Product)",
        tbl_inbound_shipment_raw: "Inbound Shipments",
        "tbl_wms_transaction_log (channel_sku)": "Transaction Log (Channel SKU)",
        "tbl_committed_order_record (channel_sku)": "Committed Orders (Channel SKU)",
      };
      return map[key] || key;
    },
    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getProduct() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "product_master_get.php",
        data: {
          product_id: this.$route.params.id,
          client_id: this.$store.state.user_obj.client_id
        }
      });

      this.product_obj = response.data.products[0];

      this.original_product_sku = this.product_obj.product_sku;
      this.original_channel_sku = this.product_obj.channel_sku;


      this.loader.hide();
    },

    showModal_reschedule_product(item) {
      this.updating_item = item;
      this.reschedule_type_selected = "before";
      this.reschedule_date = moment().format("YYYY-MM-DD");
      this.$refs.modal_reschedule_product.show();
    },

    hideModal_reschedule_product() {
      this.$refs.modal_reschedule_product.hide();
    },

    async _submitForm() {
      if (this.product_obj.actual_weight_kg == 0 || this.product_obj.actual_weight_kg > 9999) {
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Invalid Weight",
          variant: "danger",
        });
        return;
      }

      const skuChanged = this.product_obj.product_sku !== this.original_product_sku;
      const channelSkuChanged = this.product_obj.channel_sku !== this.original_channel_sku;

      if (skuChanged || channelSkuChanged) {
        const checkResponse = await this.$http({
          method: "POST",
          baseURL: `${this.API_HOST}`,
          url: "product_master_precheck.php",
          data: {
            product_id: this.product_obj.id,
            client_id: this.$store.state.user_obj.client_id,
            product_sku: this.product_obj.product_sku,
            channel_sku: this.product_obj.channel_sku,
          },
        });

        this.sku_conflict = checkResponse.data.sku_conflict || false;
        this.channel_sku_conflict = checkResponse.data.channel_sku_conflict || false;

        const affected = checkResponse.data.affected_records || {};
        const hasImpact = Object.values(affected).some(val => parseInt(val) > 0);

        if (hasImpact) {
          this.precheckSummary = affected;
          this.pendingProductData = { ...this.product_obj };
          this.$refs.modal_precheck.show();
          return;
        }
      }

      this.updateProduct(this.product_obj);
    },

    async submitForm() {
      if (this.product_obj.actual_weight_kg == 0 || this.product_obj.actual_weight_kg > 9999) {
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Invalid Weight",
          variant: "danger",
        });
        return;
      }

      const skuChanged = this.product_obj.product_sku !== this.original_product_sku;
      const channelSkuChanged = this.product_obj.channel_sku !== this.original_channel_sku;

      if (skuChanged || channelSkuChanged) {
        const checkResponse = await this.$http({
          method: "POST",
          baseURL: `${this.API_HOST}`,
          url: "product_master_precheck.php",
          data: {
            product_id: this.product_obj.id,
            client_id: this.$store.state.user_obj.client_id,
            product_sku: this.product_obj.product_sku,
            channel_sku: this.product_obj.channel_sku,
          },
        });

        this.sku_conflict = !!checkResponse.data.sku_conflict;
        this.channel_sku_conflict = !!checkResponse.data.channel_sku_conflict;

        this.sku_conflict_with = checkResponse.data.sku_conflict_with || null;
        this.channel_sku_conflict_with = checkResponse.data.channel_sku_conflict_with || null;


        const affected = checkResponse.data.affected_records || {};
        const hasImpact = Object.values(affected).some(val => parseInt(val) > 0);

        // ✅ change: conflict = warn (show confirm), not block
        const shouldWarn = this.sku_conflict || this.channel_sku_conflict;

        if (hasImpact || shouldWarn) {
          this.precheckSummary = affected;
          this.pendingProductData = { ...this.product_obj };
          this.$refs.modal_precheck.show();
          return;
        }
      }

      this.updateProduct(this.product_obj);
    },



    confirmPrecheckUpdate() {
      this.updateProduct(this.pendingProductData);
      this.pendingProductData = null;
      this.precheckSummary = {};
      this.sku_conflict = false;
      this.channel_sku_conflict = false;
      this.sku_conflict_with = null;
      this.channel_sku_conflict_with = null;
    },


    async updateProduct(product_obj) {
      const finalData = product_obj || this.pendingProductData;
      if (!finalData) return;

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "product_master_edit.php",
        data: {
          product_obj: finalData,
          user_id: this.$store.state.user_obj.user_id,
          client_id: this.$store.state.user_obj.client_id
        }
      });

      if (response.data.status == "success") {
        this.$eventHub.$emit("show_modal_message", {
          message_content: `Product updated successfully.`
        });
        this.getProduct();
      } else {
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Update failed.",
          variant: "danger"
        });
      }

      // Reset after use
      this.pendingProductData = null;
      this.precheckSummary = {};
      this.sku_conflict_with = null;
      this.channel_sku_conflict_with = null;
    },
    async getOrderMasterProduct() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_product_get.php",
        data: {
          order_number: this.product.order_number,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id
        }
      });

      this.order_master_products = response.data.products;

      this.loader.hide();
    },
    async deleteProduct() {
      try {
        const response = await this.$http({
          method: "POST",
          baseURL: `${this.API_HOST}`,
          url: "product_master_delete.php",
          data: {
            product_id: this.product_obj.id,
            user_id: this.$store.state.user_obj.user_id,
            client_id: this.$store.state.user_obj.client_id
          }
        });

        if (response.data.status === "success") {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Product deleted successfully."
          });
          this.$router.push({ name: "product_master" }); // redirect back to product list
        } else {
          this.$eventHub.$emit("show_modal_message", {
            message_content: response.data.error || "Delete failed.",
            variant: "danger"
          });
        }
      } catch (err) {
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Server error during deletion.",
          variant: "danger"
        });
        console.error(err);
      }
    },

    async confirmDeleteProduct() {
      const response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "product_master_precheck.php",
        data: {
          product_id: this.product_obj.id,
          client_id: this.$store.state.user_obj.client_id,
          product_sku: this.product_obj.product_sku,
          channel_sku: this.product_obj.channel_sku,
        }
      });

      this.precheckSummary = response.data.affected_records || {};
      const hasImpact = Object.values(this.precheckSummary).some(val => parseInt(val) > 0);

      if (hasImpact) {
        // 👇 show special delete precheck modal that triggers deleteProduct()
        this.$refs.modal_delete_precheck.show();
        this.pendingProductData = { ...this.product_obj };
      } else {
        this.$refs.modal_delete_product.show();
      }
    }
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductMasterEdit.vue